export default class {
    constructor($http, authManager, Config, toastr) {
        'ngInject';

        this.$http = $http;
        this.authManager = authManager;
        this.Config = Config;
        this.toastr = toastr;
    }

    logIn(email, password) {
        let url = this.Config.API + '/token/issue';

        return this.$http({
            method: 'POST',
            url: url,
            data: { email, password }
        }).then((response) => {

            if (!response.data.user.is_content_bank_admin && !response.data.user.is_uploader) {
                this.toastr.info("You are not allowed to access Content Bank at the moment, sorry.");
                return;
            }

            this._setUser(response.data.user, response.data.center_token);
            this.authManager.authenticate();
        });
    }

    logOut() {
        this._clearUser();
        this.authManager.unauthenticate();
        this.authManager.redirect();
    }

    _getUser() {
        var user = {};
        user.id = localStorage.getItem('userId', user.id);
        user.email = localStorage.getItem('userEmail', user.email);
        user.role = localStorage.getItem('userRole', user.role);
        user.name = localStorage.getItem('userName', user.userName);
        user.surname = localStorage.getItem('userLastName', user.userLastName);
        user.is_content_bank_admin = localStorage.getItem('userIsContentBankAdmin', user.is_content_bank_admin);
        user.is_uploader = localStorage.getItem('userIsUploader', user.is_uploader);

        return user;
    }

    /**
     * @param {Object} user
     * @param {string} token
     */
    _setUser(user, token) {
        localStorage.setItem('userId', user.id);
        localStorage.setItem('userEmail', user.email);
        localStorage.setItem('userRole', user.role);
        localStorage.setItem('userName', user.userName);
        localStorage.setItem('userLastName', user.userLastName);
        localStorage.setItem('id_token', token);
        localStorage.setItem('userIsContentBankAdmin', user.is_content_bank_admin);
        localStorage.setItem('userIsUploader', user.is_uploader);

    }

    _clearUser() {
        localStorage.removeItem('userId');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userRole');
        localStorage.removeItem('userName');
        localStorage.removeItem('userLastName');
        localStorage.removeItem('userLang');
        localStorage.removeItem('id_token');
        localStorage.removeItem('userIsContentBankAdmin');
        localStorage.removeItem('userIsUploader');
    }

    getUserInfo(id) {
        let url = this.Config.API + '/users/' + id;

        return this.$http({
            method: 'GET',
            url: url
        }).then((response) => {
            if (response.data.is_uploader) {
                localStorage.setItem("retailer_id",response.data.retailer.id);
                localStorage.setItem("retailer_name",response.data.retailer.name);
            }
        });
    }
};



// WEBPACK FOOTER //
// ./client/app/services/authentication.js